import { render, staticRenderFns } from "./_fixedAssets.vue?vue&type=template&id=c37d87f6&scoped=true&"
import script from "./_fixedAssets.vue?vue&type=script&lang=js&"
export * from "./_fixedAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d87f6",
  null
  
)

export default component.exports